/* tslint:disable */
import {
  Partner,
  PurchaseOrderLine
} from '../index';

declare var Object: any;
export interface PurchaseOrderInterface {
  "id"?: number;
  "name": string;
  "active"?: boolean;
  "gallery_id"?: number;
  "partner_id"?: number;
  "order_line"?: Array<any>;
  partner?: Partner;
  orderline?: PurchaseOrderLine[];
}

export class PurchaseOrder implements PurchaseOrderInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "gallery_id": number;
  "partner_id": number;
  "order_line": Array<any>;
  partner: Partner;
  orderline: PurchaseOrderLine[];
  constructor(data?: PurchaseOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PurchaseOrder`.
   */
  public static getModelName() {
    return "PurchaseOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PurchaseOrder for dynamic purposes.
  **/
  public static factory(data: PurchaseOrderInterface): PurchaseOrder{
    return new PurchaseOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PurchaseOrder',
      plural: 'PurchaseOrders',
      path: 'PurchaseOrders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "gallery_id": {
          name: 'gallery_id',
          type: 'number'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "order_line": {
          name: 'order_line',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        orderline: {
          name: 'orderline',
          type: 'PurchaseOrderLine[]',
          model: 'PurchaseOrderLine',
          relationType: 'referencesMany',
                  keyFrom: 'order_line',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PurchaseOrder.ts